/* eslint-disable no-param-reassign */

import {
  Scene,
  SceneLoader,
  ISceneLoaderAsyncResult,
  ShadowGenerator,
} from '@babylonjs/core';
import '@babylonjs/loaders';

export class ObjectPart {
  groupID : number = -1;
  optionID : number = -1;
  meshes : ISceneLoaderAsyncResult | undefined;
}

export async function BabylonObjectLoader(
  scene : Scene,
  meshURL : string,
  sceneFileName : string,
  groupID : number,
  optionID : number,
  shadowGenerators : ShadowGenerator[] | undefined,

) : Promise<ObjectPart> {

  const result = new ObjectPart();
  result.groupID = groupID;
  result.optionID = optionID;

  try {
    if (!scene.isDisposed) {
      await SceneLoader.ImportMeshAsync(
        '',
        meshURL,
        sceneFileName,
        scene,
      ).then((importMeshResult) => {
        importMeshResult.meshes.forEach((mesh) => {

          if (shadowGenerators) {
            shadowGenerators.forEach((shadowGenerator) => {
              shadowGenerator.addShadowCaster(mesh);
            });
          }

          mesh.freezeWorldMatrix();

          // Add meshes are shadow receivers
          mesh.receiveShadows = false;

          // Enable collisions for the mesh, because we need this for the camera movement.
          mesh.checkCollisions = true;

          // mesh.checkCollisions = false;

          // Disable the mesh at this moment.
          // If the mesh is to be visible, it will be intentionally turned on
          mesh.setEnabled(false);
        });

        result.meshes = importMeshResult;
      });
    }

    // const importMeshResult = SceneLoader.ImportMesh(
    //   '',
    //   meshURL,
    //   sceneFileName,
    //   scene,
    // );

    // Add each mesh to all shadow generators
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(`ObjectLoader(seneFile: ${sceneFileName}; meshURL : ${meshURL}; g=${groupID}; and o=${optionID})`);
    console.error(err);
  }

  return result;
}
